import { HiOutlineBriefcase, HiOutlineLocationMarker } from 'react-icons/hi';
import { experience } from '../data/content';
import Reveal from './Reveal';
import './Experience.css';

export default function Experience() {
  return (
    <section id="experience" className="section experience">
      <div className="container">
        <Reveal className="section-head">
          <span className="eyebrow">Career</span>
          <h2 className="section-title">
            Where I've <span className="gradient-text">made an impact</span>
          </h2>
          <p className="section-subtitle">
            From Kathmandu to Osaka — four years a shipping production software
            across three companies.
          </p>
        </Reveal>

        <div className="timeline">
          <div className="timeline__line" aria-hidden />
          {experience.map((job, i) => (
            <Reveal
              key={job.company + job.period}
              className="timeline__item"
              delay={i * 0.1}
            >
              <div className="timeline__marker">
                <span className={`timeline__dot ${job.current ? 'is-current' : ''}`} />
              </div>

              <div className="timeline__card card">
                <div className="timeline__head">
                  <div className="timeline__role-row">
                    <span className="timeline__icon">
                      <HiOutlineBriefcase />
                    </span>
                    <h3 className="timeline__role">{job.role}</h3>
                    {job.current && <span className="timeline__badge">Now</span>}
                  </div>
                  <span className="timeline__period mono">{job.period}</span>
                </div>

                <div className="timeline__company">
                  <span className="timeline__name">{job.company}</span>
                  <span className="timeline__loc">
                    <HiOutlineLocationMarker /> {job.location}
                  </span>
                </div>

                <p className="timeline__desc">{job.description}</p>

                <ul className="timeline__highlights">
                  {job.highlights.map((h) => (
                    <li key={h}>{h}</li>
                  ))}
                </ul>

                <div className="timeline__stack">
                  {job.stack.map((t) => (
                    <span key={t} className="chip">{t}</span>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
